import intersection from 'lodash/intersection';
export var checkRole = function checkRole(userRoles, componentRoles) {
  return !componentRoles || intersection(userRoles, componentRoles).length > 0;
};
export var getRoles = function getRoles(msalInstance) {
  var account = msalInstance.getActiveAccount();

  if (account && account.idTokenClaims && 'roles' in account.idTokenClaims) {
    return account.idTokenClaims.roles;
  }

  return [];
};